import $ from "jquery";
let Backbone_Icon_List;

let Kit_Detail;
let url_to_array;

Backbone_Icon_List = require("./backbone_iconlist").default;

url_to_array = require("../helpers/url_to_array").default;

Kit_Detail = (() => {
    function Kit_Detail() {
        let $json;
        let author;
        let is_owner;
        let kit_name;
        let template;
        $json = $("#json");
        author = $json.data("author");
        is_owner = $json.data("is-owner");
        kit_name = $json.data("kitslug");
        if (is_owner === "True") {
            template = "html";
        } else {
            template = void 0;
        }
        new Backbone_Icon_List(
            ".kit-detail-list ul",
            `//${url_to_array[2]}/json_kit_icons/user/${author}/kit/${kit_name}/`,
            2,
            template,
            48,
            $("#site-footer")
        );
    }

    return Kit_Detail;
})();

export default Kit_Detail;
